module.exports = __webpack_public_path__ + "static/media/lympne-4.bde9d6f6.jpg";